<template>
  <section>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <button class="button" @click="init">Refresh</button>
          <b-input placeholder="Search..." v-model="search_query" type="search" icon="search" icon-pack="fas" width="250"></b-input>
        </div>
      </div>
      <div class="level-center">
        <div class="level-item">
            
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <router-link class="button is-info is-pulled-right" :to="('/purchaseorder/add/' + (this.supId ? this.supId : ''))" v-can="'add_po'"><i class="fas fa-clipboard-list"></i>เพิ่มรายการสั่งซื้อ</router-link>
          </div>
        </div>
      </div>
    </nav>
    
    <div>
      <b-table
        :data="filteredData"
        selectable @click="selected"
        :selected.sync="selectedItem"
        :hoverable="true"
        :loading="isTableLoading"
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :narrowed="true"
        v-if="orders.length > 0 || isTableLoading"
      >
        <template slot-scope="props">
          <b-table-column field="id" label="ID" width="150">
            <strong>
              {{ props.row.code }}
            </strong>
          </b-table-column>

          <b-table-column field="name" label="Supplier">
              {{ props.row.sup_name }}
          </b-table-column>

          <b-table-column field="price_sell" label="จำนวน (รายการ)">
              {{ props.row.items.length }}
          </b-table-column>

          <b-table-column field="price_buy" label="ราคารวม (บาท)">
              {{ props.row.total_price ? parseFloat(props.row.total_price).formatMoney(2):0 }} บาท
          </b-table-column>

          <b-table-column field="ship_status" label="สถานะการจัดส่ง" width="130">
            <span class="tag is-warning" v-if="(props.row.received_status == 'partial' ? true:false)">รับแล้วบางส่วน</span>
            <span class="tag is-success" v-if="(props.row.received_status == 'received' ? true:false)">ได้รับแล้ว</span>
            <span class="tag is-default" v-if="(props.row.received_status == 'not' || props.row.received_status == null  ? true:false)">ยังไม่ได้รับสินค้า</span>
          </b-table-column>
          
        </template>
      </b-table>
      <div class="notification has-text-centered" v-else>ไม่พบข้อมูล</div>
    </div>
  </section>
</template>

<script>
  import PurchaseOrderModel from '@/model/purchaseorder_model';
  export default {
    props: ['supId'],
    data() {
      return {
        orders: [],
        isTableLoading: true,
        selectedItem: {},
        lastSelected: {},
        isPaginated: true,
        isPaginationSimple: false,
        currentPage: 1,
        perPage: 20,
        search_query: "",
      }
    },
    mounted() {
      this.init();
    },
    computed: {
      filteredData: function() {
        return this.orders.filter(order => {
          return (
                  (order.code && order.code.toLowerCase().includes(this.search_query.toLowerCase()))
                  || (order.sup_name && order.sup_name.toLowerCase().includes(this.search_query.toLowerCase()))

                )
        })
      }
    },
    methods: {
      async init(){
        if(this.supId){
          this.orders = await PurchaseOrderModel.get_supplier_order(this.supId);
        }else{
          this.orders = await PurchaseOrderModel.get_order();
        }
        
        this.isTableLoading = false;
      },
      selected(item) {
        if(!this.can("view_po|add_po|edit_po|receive_po_item|download_po_pdf")){
          this.$buefy.snackbar.open('คุณไม่มีสิทธิ์ที่จะเข้าถึงส่วนนี้!');
          return;
        }
        if(this.lastSelected == item){
          this.$router.push({ path: '/purchaseorder/view/'+item.id })
        }
        this.lastSelected = item;
      }
    }

  }
</script>


// WEBPACK FOOTER //
// src/components/purchase_order.vue